export enum RulItemTypeType {
    /**
     * Povinný
     */
    REQUIRED = 'REQUIRED',

    /**
     * Doporučený
     */
    RECOMMENDED = 'RECOMMENDED',

    /**
     * Možný
     */
    POSSIBLE = 'POSSIBLE',

    /**
     * Nemožný
     */
    IMPOSSIBLE = 'IMPOSSIBLE',
}
